import DefaultFlag from "app/images/flags/WW.svg";
import type { Element } from "React";
import React, { Component } from "react";
import { FlagIcon } from "react-flag-kit";
import "./Flag.scss";

type Props = {
  code: string | any;
  size: number;
};

class Flag extends Component<Props> {
  render(): Element<"div"> {
    let { code, size } = this.props;
    return (
      <React.Fragment>
        {code === "WW" ? (
          <img width={size} height={size} src={DefaultFlag} alt={""} />
        ) : (
          <FlagIcon code={code} size={size} />
        )}
      </React.Fragment>
    );
  }
}

export default Flag;
